/* OLAPLEX inline add-to-cart for product cards (#18 B/C).
   Single-variant → "Agregar". Multi-variant (#25, formato olaplex.com) → el botón
   dice "Elegir tamaño"; al abrirlo despliega las pastillas de tamaño hacia arriba
   y, al elegir una, el mismo botón pasa a "Agregar".
   Agrega vía /cart/add.js y actualiza la burbuja del carrito del header. */
(function () {
  function bubble(count) {
    var wrap = document.querySelector('#cart-icon-bubble');
    if (!wrap) return;
    var b = wrap.querySelector('.cart-count-bubble');
    if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; wrap.appendChild(b); }
    b.innerHTML = '<span aria-hidden="true">' + count + '</span>';
  }

  function closeAll(except) {
    document.querySelectorAll('olx-card-add').forEach(function (el) {
      if (el === except) return;
      var panel = el.querySelector('.olx-add-panel');
      var toggle = el.querySelector('[data-olx-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* #46 — tras agregar, la carta vuelve a "Elegir tamaño" (pastillas limpias) para
     que el próximo agregado vuelva a pedir el tamaño. Solo aplica a cartas cuyo
     toggle fue convertido por una pastilla (olxToggleHtml); las de un tamaño y las
     preseleccionadas (data-olx-preselect) se quedan en "Agregar". */
  function resetCard(addEl) {
    if (!addEl) return;
    var btn = addEl.querySelector('[data-olx-add]');
    if (!btn || !btn.olxToggleHtml) return;
    btn.innerHTML = btn.olxToggleHtml;
    btn.removeAttribute('data-olx-add');
    btn.removeAttribute('data-olx-variant');
    btn.setAttribute('data-olx-toggle', '');
    btn.setAttribute('aria-expanded', 'false');
    btn.classList.remove('olx-add');
    btn.classList.add('olx-add-toggle');
    var panel = addEl.querySelector('.olx-add-panel');
    if (panel) panel.hidden = true;
    addEl.querySelectorAll('.olx-size').forEach(function (s) { s.setAttribute('aria-pressed', 'false'); });
  }

  /* #26 — Hoja inferior móvil (ref olaplex.com): un solo nodo en <body> que se
     rellena con los datos de la carta (título, precio, tamaños). El botón "Agregar
     al carrito" reutiliza el flujo [data-olx-add] de abajo. */
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var sheet = null;
  function getSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'olx-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML =
      '<div class="olx-sheet__backdrop" data-olx-sheet-close></div>' +
      '<div class="olx-sheet__panel">' +
        '<div class="olx-sheet__head"><p class="olx-sheet__title" data-olx-sheet-title></p>' +
        '<button type="button" class="olx-sheet__close" data-olx-sheet-close aria-label="Cerrar">' +
        '<svg viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l16 16M17 1L1 17"/></svg></button></div>' +
        '<p class="olx-sheet__price" data-olx-sheet-price></p>' +
        '<p class="olx-sheet__label">Selecciona un tamaño:</p>' +
        '<div class="olx-sheet__sizes" data-olx-sheet-sizes></div>' +
        '<button type="button" class="olx-sheet__add" data-olx-add data-olx-variant="" disabled><span data-olx-label>Agregar al carrito</span></button>' +
      '</div>';
    document.body.appendChild(sheet);
    return sheet;
  }
  function openSheet(addEl) {
    var sh = getSheet();
    sh.olxAddEl = addEl;
    var priceEl = addEl.closest('.olx-price-row');
    priceEl = priceEl && priceEl.querySelector('.price-item--regular, .price-item--sale');
    sh.querySelector('[data-olx-sheet-title]').textContent = addEl.dataset.olxTitle || '';
    sh.querySelector('[data-olx-sheet-price]').textContent = priceEl ? priceEl.textContent.trim() : '';
    var sizes = sh.querySelector('[data-olx-sheet-sizes]');
    sizes.innerHTML = '';
    addEl.querySelectorAll('.olx-size').forEach(function (src) {
      var b = src.cloneNode(true);
      b.setAttribute('aria-pressed', 'false');
      sizes.appendChild(b);
    });
    var add = sh.querySelector('.olx-sheet__add');
    add.dataset.olxVariant = '';
    add.disabled = true;
    sh.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
  }
  function closeSheet() {
    if (!sheet) return;
    sheet.removeAttribute('open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-olx-sheet-close]')) { closeSheet(); return; }

    var toggle = e.target.closest('[data-olx-toggle]');
    if (toggle && MOBILE.matches) { openSheet(toggle.closest('olx-card-add')); return; }
    if (toggle) {
      var addEl = toggle.closest('olx-card-add');
      var panel = addEl.querySelector('.olx-add-panel');
      var willOpen = panel.hidden;
      closeAll(addEl);
      panel.hidden = !willOpen;
      toggle.setAttribute('aria-expanded', String(willOpen));
      return;
    }

    var size = e.target.closest('.olx-size');
    if (size && !size.disabled && size.closest('.olx-sheet')) {
      sheet.querySelectorAll('.olx-size').forEach(function (s) { s.setAttribute('aria-pressed', String(s === size)); });
      sheet.querySelector('[data-olx-sheet-price]').textContent = size.dataset.olxPrice || '';
      var sheetAdd = sheet.querySelector('.olx-sheet__add');
      sheetAdd.dataset.olxVariant = size.dataset.olxVariant;
      sheetAdd.disabled = false;
      return;
    }
    if (size && !size.disabled) {
      var sizeEl = size.closest('olx-card-add');
      sizeEl.querySelectorAll('.olx-size').forEach(function (s) { s.setAttribute('aria-pressed', String(s === size)); });
      /* El toggle se convierte en el botón de agregar (ref olaplex.com): mismo
         control, etiqueta "Agregar" y sin chevron. El panel queda abierto para
         poder cambiar de tamaño. */
      var btn = sizeEl.querySelector('[data-olx-toggle], [data-olx-add]');
      if (btn.hasAttribute('data-olx-toggle')) btn.olxToggleHtml = btn.innerHTML;
      btn.removeAttribute('data-olx-toggle');
      btn.removeAttribute('aria-expanded');
      btn.dataset.olxAdd = '';
      btn.classList.remove('olx-add-toggle');
      btn.classList.add('olx-add');
      btn.dataset.olxVariant = size.dataset.olxVariant;
      btn.innerHTML = '<span data-olx-label>Agregar</span>';
      return;
    }

    var addBtn = e.target.closest('[data-olx-add]');
    if (addBtn && !addBtn.disabled) {
      var id = addBtn.dataset.olxVariant;
      if (!id) return;
      var label = addBtn.querySelector('[data-olx-label]') || addBtn;
      var original = label.textContent;
      addBtn.disabled = true;
      label.textContent = 'Agregando…';
      /* #40 — mismo patrón que product-form/video sheet: /cart/add.js con `sections`
         devuelve el HTML del drawer YA actualizado en la misma respuesta (antes se
         actualizaba solo la burbuja y el drawer quedaba con el HTML viejo). */
      var cartEl = document.querySelector('cart-drawer');
      var body = { items: [{ id: Number(id), quantity: 1 }] };
      if (cartEl && cartEl.getSectionsToRender) {
        body.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (data) {
            return { ok: res.ok && !data.status, data: data };
          });
        })
        .then(function (r) {
          if (!r.ok) return Promise.reject();
          label.textContent = original;
          addBtn.disabled = false;
          if (addBtn.closest('.olx-sheet')) closeSheet();
          resetCard(addBtn.closest('olx-card-add') || (addBtn.closest('.olx-sheet') && getSheet().olxAddEl));
          if (cartEl && cartEl.renderContents && r.data.sections) {
            cartEl.renderContents(r.data);
          } else {
            fetch('/cart.js')
              .then(function (cr) { return cr.json(); })
              .then(function (cart) { bubble(cart.item_count); });
          }
        })
        .catch(function () { label.textContent = original; addBtn.disabled = false; });
      return;
    }

    if (!e.target.closest('olx-card-add')) closeAll(null);
  });
})();
